import { Store as VStore } from 'vuex'
import { EnterpriseType, EnterpriseTypes, PastureKeys, Store } from '@/store';
import { fromDate } from '../dates';
import { BreedNamesShort } from './JSON';

export interface Context {
	store: VStore<Store>;
}

export interface ContextMonth extends Context {
	month: number;
	monthIndex: number;
}

export interface ContextMonthSupply extends ContextMonth {
	pastureKey: PastureKeys;
	type?: 'pasture' | 'total';
}

export function GetDate(ctx: Context) {
	if (!ctx.store.state.pasture?.simulation?.date) return null;
	return fromDate(ctx.store.state.pasture.simulation.date);
}

export function GetBreedTypeIndex(breedName: string, names: string[]) {
	const index = names.indexOf(breedName);

	if (index > -1) return index + 1;

	return null;
}

export function GetEnterpriseIndex(name: EnterpriseType) {
	const index = EnterpriseTypes.indexOf(name);
	if (index > -1) return index + 1;
	return null;
}

export function GetEnterpriseIndexFromContext(ctx: Context) {
	return GetEnterpriseIndex(ctx.store.state.pasture!.simulation.enterprise!);
}

export function GetMonth(month: number) {
	if (month > 12) month = month % 12;
	if (month < 0) month = 12 + month;
	return month;
}

export function GetPastures(ctx: ContextMonth) {
	const index = ctx.month - 1;
	const pasture = ctx.store.state.pasture!.monthlyPasture[index];
	const keys = Object.keys(pasture).filter(x => x.indexOf('p') === 0);
	return keys.map(p => ({
		pastureKey: p as PastureKeys,
		data: pasture[p as PastureKeys],
	}))
}

export function getShortBreedName(breedName: string) {
	return breedName.replace(/\s/g, "") as BreedNamesShort;
}

// replicates excel IF functionality in formulas
export function IF<T>(condition: boolean, a: T, b: T) {
	if (condition) {
		return a;
	} else {
		return b;
	}
}

/// Caches a computed value
export function cache<T>(key: string, ctx: any, data: () => T): T {
	if (typeof ctx.cache == 'undefined') {
		ctx.cache = {};
	}
	const cache = ctx.cache;
	if (key in cache) {
		return cache[key];
	}

	// eslint-disable-next-line no-return-assign
	return cache[key] = data();
}
